const rootElement = document.querySelector('[data-selector="hb-lp-compare-container"]')

const swiper = new Swiper(rootElement.querySelector('[data-selector="swiper"]'), { 
  spaceBetween: 10, 
  slidesPerView: 1.2, 
  loop: false,
  navigation: {
    nextEl: rootElement.querySelector('[data-selector="next-button"]'),
    prevEl: rootElement.querySelector('[data-selector="prev-button"]')
  },
  breakpoints: {
    0: {
      slidesPerView: 2
    },
    768: {
      slidesPerView: 3
    }
  }
})
